import { render, staticRenderFns } from "./ConditionsOfCooperation.vue?vue&type=template&id=1fbf35dd&scoped=true"
import script from "./ConditionsOfCooperation.vue?vue&type=script&lang=js"
export * from "./ConditionsOfCooperation.vue?vue&type=script&lang=js"
import style0 from "./ConditionsOfCooperation.vue?vue&type=style&index=0&id=1fbf35dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf35dd",
  null
  
)

export default component.exports